import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  private usuarioLogado = false;
  constructor(
    private authentication: AuthenticationService,
    private router: Router,
    private location: Location
  ) {
    this.authentication.authNavStatus$.subscribe({
      next: (status) => {
        this.usuarioLogado = status;
      }
    });
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const autorizacaoNecessaria = route.data.autorizacaoNecessaria;
    if (!this.usuarioLogado) {
      this.router.navigate(['/login']);
      return false;
    }
    const autorizacoes = this.authentication.obterToken()['autorizacoes'];

    if (!autorizacoes.visualizarDashboard) {
      this.router.navigate(['/sem-autorizacoes']);
      return false;
    }

    const autorizado: boolean | undefined = autorizacoes[autorizacaoNecessaria];
    if (autorizado) {
      return autorizado;
    }

    if (this.router.url === '/') {
      this.location.back();
    }

    return false;
  }
}
